import { ViteReactSSG } from 'vite-react-ssg'
import { routes } from '@/router/routes'
import i18n from '@/i18n/config'
import '@/style.css'

export const createRoot = ViteReactSSG(
  { routes },

  async ({ routePath, isClient }) => {
    // Durante SSG (Node.js): definir idioma com base no prefixo da URL
    if (!isClient && routePath) {
      const lang =
        routePath.startsWith('/en') ? 'en-US' :
        routePath.startsWith('/es') ? 'es-ES' : 'pt-BR'
      await i18n.changeLanguage(lang)
    }

    // Apenas no browser: registrar Service Worker
    if (isClient && import.meta.env.PROD) {
      if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
          navigator.serviceWorker
            .register('/sw.js', { scope: '/' })
            .then(reg => console.info('[SW] Registrado:', reg.scope))
            .catch(err => console.warn('[SW] Falha no registro:', err))
        })
      }
    }
  },
)
